define('src/plugins/epoxy.extension',[
    'epoxy', 'markdown',
], function(Epoxy, markdown) {

    /**
     * Adds the "markdown()" filter to Epoxy views that transforms Markdown into HTML
     */
    Epoxy.binding.addFilter('markdown', function(text, options) {
        return markdown(text || '', options);
    });

    /**
     * Adds the "markdown:" binding handler that sets a Markdown value to a jQuery element
     */
    Epoxy.binding.addHandler('markdown', function($element, value) {
        $element.html(markdown(value || '', { sanitize: true }).trim());
        $element.find('a').attr('target', '_blank');
    });

    /**
     * Adds the "if:" binding handler that give the possibility to add conditionnal value to a jQuery element
     */
    Epoxy.binding.addHandler('if', function($element, value) {
    	var isDetached = $element[0].parentNode === null;
    	var shouldBeRendered = value;
    	var comment = $element.data('epoxy-placeholder-comment');

    	//The element is detached but should be rendered. Replace the comment with the element.
    	if (isDetached && shouldBeRendered && comment) {
    		comment.replaceWith($element);
    	}
    	//The element is currently attached but should not be rendered.
    	else if (!isDetached && !shouldBeRendered) {
    		//If it's a first, we haven't created a placeholder comment node yet.
    		if (!comment) {
    			comment = document.createComment('epoxy-placeholder');
    			$element.data('epoxy-placeholder-comment', comment);
    		}

    		$element.after(comment).detach();
    	}
    });
});

